import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";
import { Button } from "components/common/Button";
import RadioControl from "components/common/RadioControl/RadioControl";
import styles from "./index.module.scss";
import classNames from "classnames";
import ToolbarControl from "components/common/Toolbar/ToolbarControl";
import { ReactComponent as IconClose } from "components/icons/close.svg";
import RadixSelect from "components/common/RadixSelect";
import dictMap from "lib/helpers/dictMap";
import context from "lib/stores/context";
import ProductIcons from "components/icons/products";
import mapData from "lib/stores/mapData";
import apiData from "lib/stores/apiData";
import { useSnapshot } from "valtio";

const ProductsControlBarMobile = () => {
  const { selectedProduct, year, productsCountry } = useSnapshot(mapData);
  const { countries } = useSnapshot(apiData);
  const [showBar, setShowBar] = useState(false);

  const changeHandler = (value: string) => {
    mapData.selectedProduct = value;
  };

  const renderButtons = () => {
    try {
      const country = countries[productsCountry];
      let imports = new Set();
      country?.imports?.forEach(imp => {
        const product = {
          name: imp.product,
          value: imp.product.toLowerCase()
        };
        imports.add(JSON.stringify(product));
      });
      imports = Array.from(imports).map(imp => {
        const product = JSON.parse(imp);
        product.icon = getIconForProduct(product.value);
        return {
          label: product.name.charAt(0).toUpperCase() + product.name.slice(1),
          value: product.value
        };
      });
      return imports;
    } catch (error) {
      return [];
    }
  };

  const getIconForProduct = product => {
    switch (product) {
      case "electronics":
        return <ProductIcons.Electronics />;
      case "fish":
        return <ProductIcons.Fish />;
      case "sugarcane":
        return <ProductIcons.Sugarcane />;
      case "cocoa":
        return <ProductIcons.Cocoa />;
      case "garments":
        return <ProductIcons.Garments />;
      default:
        return <ProductIcons.Electronics />;
    }
  };

  const onClick = () => {
    mapData.selectedProduct = null;
  };

  // const getPlaceholder = () => {
  //   try {
  //     if (countries[productsCountry]) {
  //       return `${countries[productsCountry].name} (${productsCountry})`;
  //     } else {
  //       return "Select Country";
  //     }
  //   } catch (error) {
  //     return "Select Country";
  //   }
  // };

  return (
    <>
      <div className={classNames(styles["imports-control-bar-mobile"], "pointer-events-auto")}>
        <ToolbarControl label="Choose a product" className={classNames(styles["radix-select-mobile-map-controls-wrapper"])}>
          <RadixSelect
            onValueChange={product => {
              mapData.selectedProduct = product;
            }}
            value={selectedProduct}
            placeholder={selectedProduct ? selectedProduct.charAt(0).toUpperCase() + selectedProduct.slice(1).replace(/%20/g, ' ') : "Choose a Product"}
            triggerClassName={classNames(styles["radix-select-mobile-map-controls"], "border-[1px] border-black")}
            selectContentClassName="-translate-x-[2px] max-h-[800px] md:w-64 lg:w-48 xl:w-64"
            groups={[
              {
                label: "Choose A Product",
                items: [...renderButtons()]
              }
            ]}
          />
        </ToolbarControl>
        {/* Clear Selection Button */}
        {productsCountry && selectedProduct && (
          <ToolbarControl className={styles["clear-selection-button"]} contentsClassName={styles.contents}>
            <Button icon={<IconClose />} onClick={onClick} variant="secondary">
              Clear <span className={styles["condense-span"]}>Selection</span>
            </Button>
          </ToolbarControl>
        )}
      </div>
    </>
  );
};

export default ProductsControlBarMobile;
